import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartintegVisualizacaoService } from '../../../../services/smartinteg-visualizacao.service';
import { RegistroRecebidoDetalheResponse, RegistroVisualizacaoDetalheResponse } from '../../../../types/smartinteg';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-registro-detalhe',
  templateUrl: './registro-detalhe.component.html',
  styleUrls: ['./registro-detalhe.component.css']
})
export class RegistroDetalheComponent implements OnInit {
  registroId!: number;
  registro?: any; // Pode ser RegistroRecebidoDetalheResponse ou RegistroVisualizacaoDetalheResponse (adaptado)
  tipo: 'recebidos' | 'visualizacao' = 'recebidos';
  loading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private visualizacaoService: SmartintegVisualizacaoService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.registroId = +this.route.snapshot.paramMap.get('id')!;
    this.route.queryParams.subscribe(params => {
      this.tipo = params['tipo'] === 'visualizacao' ? 'visualizacao' : 'recebidos';
      this.carregarDetalhes();
    });
  }

  carregarDetalhes(): void {
    this.loading = true;

    if (this.tipo === 'visualizacao') {
      this.visualizacaoService.getDetalheRegistroVisualizacao(this.registroId)
        .subscribe({
          next: (data) => {
            // Adaptar para estrutura comum para facilitar o template
            this.registro = {
              ...data,
              payloadOriginal: data.dados,
              dadosProcessados: data.dadosTransformados,
              dataRecebimento: data.criadoEm,
              // Campos ausentes na visualização
              hashPayload: '-',
              ipOrigem: 'Sistema',
              timeline: [],
              headers: {}
            };
            this.loading = false;
          },
          error: (err) => {
            this.toastService.erro('Erro', 'Falha ao carregar detalhes do registro de visualização.');
            this.loading = false;
          }
        });
    } else {
      this.visualizacaoService.getDetalheRegistroRecebido(this.registroId)
        .subscribe({
          next: (data) => {
            this.registro = data;
            this.loading = false;
          },
          error: (err) => {
            this.toastService.erro('Erro', 'Falha ao carregar detalhes do registro recebido.');
            this.loading = false;
          }
        });
    }
  }

  copiarPayload(payload: any): void {
    navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
    this.toastService.sucesso('Copiado', 'Payload copiado para a área de transferência.');
  }

  copiarTexto(texto: string): void {
    navigator.clipboard.writeText(texto);
    this.toastService.sucesso('Copiado', 'Texto copiado para a área de transferência.');
  }

  formatarJson(obj: any): string {
    if (!obj) return '';
    try {
      return JSON.stringify(obj, null, 2);
    } catch {
      return String(obj);
    }
  }

  hasHeaders(headers: Record<string, string>): boolean {
    return !!headers && Object.keys(headers).length > 0;
  }

  voltar(): void {
    window.history.back();
  }
}
